import { SETTINGS_V2_RESOURCES, PAGE_NAMES } from '../../settingsV2Constant';
// import user from 'assets/settingsV2/user.png';
import user from '../../assets/settingsV2/user.png';
import permissions from '../../assets/settingsV2/permissionManagement.png';
import bulkUserCsvImg from '../../assets/settingsV2/bulkUserCsv.png';
import UserDashboard from './userManagement';
import PermissionsDashboard from './permissionsManagement';
import BulkUserCsvDashboard from './bulkUserCsv';

export const URL = {
	[SETTINGS_V2_RESOURCES.user]: `/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.user}`,
	[SETTINGS_V2_RESOURCES.permissionsManagement]: `/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.permissionsManagement}`,
	[SETTINGS_V2_RESOURCES.bulkUserCsv]: `/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.bulkUserCsv}`
};

export const LABEL = {
	[SETTINGS_V2_RESOURCES.user]: 'User Management',
	[SETTINGS_V2_RESOURCES.permissionsManagement]: 'Permission Management',
	[SETTINGS_V2_RESOURCES.bulkUserCsv]: 'Bulk User Management'
};

export const COMPONENT = {
	[SETTINGS_V2_RESOURCES.user]: UserDashboard,
	[SETTINGS_V2_RESOURCES.permissionsManagement]: PermissionsDashboard,
	[SETTINGS_V2_RESOURCES.bulkUserCsv]: BulkUserCsvDashboard
};

export const IMAGE_SOURCE = {
	[SETTINGS_V2_RESOURCES.user]: user,
	[SETTINGS_V2_RESOURCES.permissionsManagement]: permissions,
	[SETTINGS_V2_RESOURCES.bulkUserCsv]: bulkUserCsvImg
};
